import {TopReelFeature} from "./TopReelFeature";
import {FeatureList, GameConfig} from "../../../../GameConfig";
import {gsap} from "gsap";
import {HOTB} from "../../../../HOTB";
import {SymbolsList} from "../../../../reels/GameSymbol";
import {AnimUtils} from "../../../../utils/AnimUtils";
import {GameSounds} from "../../../../sound/GameSounds";

export class WildFeature extends TopReelFeature {
    constructor(reelId: number) {
        super(reelId, FeatureList.WILD);
    }

    public finishDrop(): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();

        tl.add([
            super.finishDrop(),
            (): void => {
                AnimUtils.playScreenShake(GameConfig.itemDropShakePower);
                HOTB.soundPlayer.playSound(GameSounds.WILD_LAND);
            }
        ]);

        tl.add((): void => {
            HOTB.reelArea.mainReelModels[this.reelId].reelView.transformSymbol(this.reelId, this.dropPosId, SymbolsList.WILD);
        }, (18 / GameConfig.defaultFPS));

        if (this.isNextWildFeature(this.reelId, HOTB.model.gameData.reelTop)) {
            tl.timeScale(1.5);
        }

        return tl;
    }

    private isNextWildFeature(index: number, myArr: string[]): boolean {
        if (myArr[index] !== FeatureList.WILD) {
            return false;
        }

        for (let i: number = index + 1; i < myArr.length; i++) {
            if (myArr[i] === FeatureList.DEAD) continue; // Skip all Dead Features
            return myArr[i] === FeatureList.WILD; // Return true if the next valid item is Wild Feature, otherwise false
        }

        return false;
    }
}